<section #footerElement>

    @if (this.isLoginPage) {
        <div id="loginFooter">
            <div>&nbsp;</div>
            <div class="loginLinks">
                <div>
                    <a href="https://www.softprocorp.com/softpro-support/" target="_blank">Contact Support</a>
                </div>
                <div class="spacer"></div>    
                <div>
                    <a href="https://fnf.com/privacy-and-security" target="_blank">Privacy Notice</a>
                </div> 
                <div class="spacer"></div>     
                <div>
                    <a href="https://fnf.com/california-privacy" target="_blank">California Privacy Notice</a>
                </div>
                <div class="spacer"></div>   
                <div>
                    <a href="https://www.fnf.com/terms-of-use" target="_blank">Terms of Use</a>
                </div>
                <div class="spacer"></div>   
                <div>
                    <a href="https://fnf.com/accessibility" target="_blank">Accessibility</a>
                </div>
            </div>
            <div class="copywright"><span>&copy;</span>&nbsp; {{this.copyWright}}</div>
        </div>
    } @else if (this.isHostedPortalPage) {
        <div id="portal-note">
            <div>
                *The last logon date is not designed to provide real-time log information and reporting will lag 9-14 days behind the current date.
            </div>    
        </div>
    } @else if (!this.isHomePage) {
        <div id="contact-info">
            <div>
                <strong>Contact:</strong>
                <address>4800 Falls of Neuse Rd, Suite 600, Raleigh, NC 27609</address>
            </div>    
            <div>
                <strong>Email:</strong>
                <address><a href="mailto:support&#64;softprocorp.com">support&#64;softprocorp.com</a></address>
            </div>   
            <div>
                <strong>Phone:</strong>
                <address>(800) 848-0143</address>
            </div>
        </div>
    } 

</section>

